import { Btn, Eyebrow, Section } from '@ui/library';
import { notFoundCopy } from '@content/ui-strings';

export function NotFoundRoute() {
  return (
    <Section className="not-found">
      <div style={{ minHeight: '50vh', display: 'flex', alignItems: 'center' }}>
        <div>
          <Eyebrow>{notFoundCopy.eyebrow}</Eyebrow>
          <h1 style={{ marginTop: 12 }}>{notFoundCopy.title}</h1>
          <p style={{ marginBottom: 24 }}>{notFoundCopy.body}</p>
          <Btn kind="primary" href="/" icon="arrow-right">{notFoundCopy.homeLabel}</Btn>
        </div>
      </div>
    </Section>
  );
}
